import React from 'react';
import { Moment } from 'moment';
import { DatePicker, FocusedInputShape } from '@inplayer-org/inplayer-ui';

interface Props {
  onDateChange: (dateObject: any) => any;
  startDate: Moment;
  endDate: Moment;
  focusedInput: FocusedInputShape | null;
  handleFocusChange: (focusedInput: FocusedInputShape | null) => void;
}

export const TODAY = '1D';
export const ONE_WEEK = '1W';
export const TWO_WEEKS = '2w';
export const ONE_MONTH = '1M';
export const SIX_MONTHS = '6M';
export const ONE_YEAR = '1Y';
export const ALL = 'ALL';

interface State {
  activePeriod: string;
}

export default class SubHeader extends React.PureComponent<Props, State> {
  format = 'YYYY-M-D H:m:s';

  state = {
    activePeriod: ONE_MONTH,
  };

  handleDateChange = ({ startDate, endDate }: any) => {
    const { onDateChange } = this.props;

    if (startDate) {
      if (endDate) {
        // +1 to include the startDate
        const days = endDate.diff(startDate, 'days') + 1;
        let interval = 'day';

        if (days === 1) {
          interval = 'hour';
        } else if (days > 62) {
          interval = 'month';
        }

        this.setState({ activePeriod: '' });

        onDateChange({ startDate, endDate, interval });
      } else {
        // for single date picker
        const newEndDate = startDate.clone();

        const interval = 'day';

        onDateChange({ startDate, endDate: newEndDate, interval });
      }
    }
  };

  render() {
    const { startDate, endDate, focusedInput, handleFocusChange } = this.props;

    return (
      <div data-tut="reactour__analytics-subheader">
        <DatePicker
          showPresets
          startDate={startDate}
          endDate={endDate}
          onDateChange={this.handleDateChange}
          onFocusChange={handleFocusChange}
          focusedInput={focusedInput}
          minimumNights={0}
        />
      </div>
    );
  }
}
